import request from "@/util/request";
import { API_BASE_URL } from "../constant";
import { getToken } from "./auth";
import { postApiRtt } from './performance';

export const getCurrentUser = () => requestWapperWithRtt("/back/auth/me", "GET", null);

// 获取指纹登录code
export const getSignUpCode = () =>
  requestWapperWithRtt("/back/auth/getSignUpCode", "GET", null);

// 用code获取user_key
export const signUpWithCode = (params) =>
  requestWapper("/back/auth/signUpWithCode", "POST", params);

// 获取游戏基本信息
export const getMatrixInfoByGameId = (gameId, isH5 = false) =>
  requestWapperWithRtt(
    "/back/cloudgame/gameID/" + gameId + "?type=" + (isH5 ? "h5" : "pc"),
    "GET",
    null
  );

// 获取游戏状态
export const getSecByGameID = (gameId) =>
  requestWapperWithRtt("/back/cloudgame/getSec", "GET", { sUID: gameId });

// 拉取公告信息
export const getNotification = (gameid) =>
  requestWapper(`/back/cloudgame/notification?sUID=${gameid}`, "GET", null);

// 测速信息上报
export const postSpeedTestData = (params) =>
  requestWapper("/back/cloudgame/speedTest", "POST", params);
// 测速信息监听
export const getSpeedTestStatus = (params) =>
  requestWapper("/back/cloudgame/speedTest/check", "GET", params);
// 上传debug数据
export const postDebugData = (params) =>
  requestWapper("/perf/web-save", "POST", params);
// 校验discord时效性
export const checkDiscordLink = (params) =>
  requestWapper(`/back/hok/limit/check`, "GET", params);

// 获取个人排名和个人信息
export const getPersonalRank = (params) =>
  requestWapper(`/back/hok/thirdPart/rank`, "GET", params);

// 获取排行榜
export const getRankList = (params) =>
  requestWapper(`/back/hok/thirdPart/rankList`, "GET", params);

// 上报接口RTT
export const postApiRttData = (params) =>
  requestWapper("/perf/saveAPI", "POST", params);

// 获取游戏信息（合并接口）
export const getGameInfo = (params) =>
requestWapperWithRtt(`/back/cloudgame/initWeb`, "GET", params);

/**
 * 添加游戏的bug/建议反馈
 * @param content 反馈的内容
 */
export const addcloudGameFeedback = (content) =>
requestWapper("/back/cloudgame/feedback/add", "POST", content);


// 获取游戏信息（合并接口）
export const getCostTime = (params) =>
  requestWapper(`/back/cloudgame/getCostTime`, "GET", params);

// 上报tlog接口
export const postTlogData = (params) =>
  requestThirdWapper("POST", params);

const requestWapper = (pathInfo, method, data) => {
  let url = API_BASE_URL + "/v1" + pathInfo;
  if (method === "GET" && data) url = url + "?" + new URLSearchParams(data);
  let headers = {
    "Content-Type": "application/json", //设置跨域头部
    Authorization: getToken() ? getToken() : "",
  };
  return request({
    url: url,
    method: method,
    data: data,
    headers: headers,
  })
    .then((res) => {
      if (res.code !== 0) {
        return Promise.reject(res);
      }
      return res;
    })
    .catch((err) => {
      return err;
    });
};

// 统计接口RTT
const requestWapperWithRtt = (pathInfo, method, data) => {
  let url = API_BASE_URL + "/v1" + pathInfo;
  if (method === "GET" && data) url = url + "?" + new URLSearchParams(data);
  let headers = {
    "Content-Type": "application/json", //设置跨域头部
    Authorization: getToken() ? getToken() : "",
  };
  const startTime = Date.now();
  return request({
    url: url,
    method: method,
    data: data,
    headers: headers,
  })
    .then((res) => {
      if (res.code !== 0) {
        return Promise.reject(res);
      }
      const endTime = Date.now();
      postApiRtt(pathInfo, endTime - startTime);
      return res;
    })
    .catch((err) => {
      return err;
    });
};

const requestThirdWapper = (method, data) => {
  let url = "https://na-community.playerinfinite.com/api/gpts_community.report_svr.ReportSvr/ReportStatInfo";
  if (method === "GET" && data) url = url + "?" + new URLSearchParams(data);
  let headers = {
    "Content-Type": "application/json", //设置跨域头部
    "X-Language": "en",
    "X-Gameid": "29080",
    "X-Source": "pc_web",
  };
  return request({
    url: url,
    method: method,
    data: data,
    headers: headers,
  })
    .then((res) => {
      if (res.code !== 0) {
        return Promise.reject(res);
      }
      return res;
    })
    .catch((err) => {
      return err;
    });
};